import {makeStyles} from '@material-ui/core';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
    Link,
    Sidebar,
    sidebarConfig,
    SidebarDivider,
    SidebarGroup,
    SidebarItem,
    SidebarPage,
    SidebarScrollWrapper,
    SidebarSpace,
    useSidebarOpenState,
} from '@backstage/core-components';
import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import {PropsWithChildren} from 'react';
import ExtensionIcon from '@material-ui/icons/Extension';
// import LibraryBooks from '@material-ui/icons/LibraryBooks';
import {Settings as SidebarSettings, UserSettingsSignInAvatar,} from '@backstage/plugin-user-settings';
import {SidebarSearchModal} from '@backstage/plugin-search';
import SearchIcon from '@material-ui/icons/Search';
import {MyGroupsSidebarItem} from '@backstage/plugin-org';
import GroupIcon from '@material-ui/icons/People';
import {NotificationsSidebarItem} from '@backstage/plugin-notifications';
import AppsIcon from '@material-ui/icons/Apps';
import { Administration } from '@backstage-community/plugin-rbac';

const useSidebarLogoStyles = makeStyles({
    root: {
        width: sidebarConfig.drawerWidthClosed,
        height: 3 * sidebarConfig.logoHeight,
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        marginBottom: -14,
    },
    link: {
        width: sidebarConfig.drawerWidthClosed,
        marginLeft: 24,
    },
});

const SidebarLogo = () => {
    const classes = useSidebarLogoStyles();
    const {isOpen} = useSidebarOpenState();

    return (
        <div className={classes.root}>
            <Link to="/" underline="none" className={classes.link} aria-label="Home">
                {isOpen ? <LogoFull/> : <LogoIcon/>}
            </Link>
        </div>
    );
};

export const Root = ({children}: PropsWithChildren<{}>) => (
    <SidebarPage>
        <Sidebar>
            <SidebarLogo/>
            <SidebarGroup label="Search" icon={<SearchIcon/>} to="/search">
                <SidebarSearchModal/>
            </SidebarGroup>
            <SidebarDivider/>
            <SidebarGroup label="Menu" icon={<MenuIcon/>}>
                {/* Global nav, not org-specific */}
                <SidebarItem icon={HomeIcon} to="home" text="Home"/>
                <SidebarItem icon={ExtensionIcon} to="catalog" text="Componentes"/>

                {/*<SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs"/>*/}
                {/*<SidebarItem icon={LibraryBooks} to="docs" text="Docs"/>*/}
                <SidebarItem icon={AppsIcon} to="create" text="Dev store"/>
                <MyGroupsSidebarItem
                    singularTitle="Meu Grupo"
                    pluralTitle="Meus Grupos"
                    icon={GroupIcon}
                />
                {/* End global nav */}
                <SidebarDivider/>
                <SidebarScrollWrapper>
                    {/* Items in this group will be scrollable if they run out of space */}
                </SidebarScrollWrapper>
            </SidebarGroup>
            <SidebarSpace/>
            <SidebarDivider/>
            <NotificationsSidebarItem text={'Notificações'}/>
            <SidebarDivider/>
            <Administration />
            <SidebarGroup
                label="Configurações"
                icon={<UserSettingsSignInAvatar/>}
                to="/settings"
            >
                <SidebarSettings/>
            </SidebarGroup>
        </Sidebar>
        {children}
    </SidebarPage>
);